// // import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
// // import {
// //   Box, Grid, Card, CardContent, Typography, CircularProgress,
// //   Chip, ToggleButtonGroup, ToggleButton, FormControl,
// //   InputLabel, Select, MenuItem,
// // } from "@mui/material";
// // import {
// //   Factory, Warehouse, CheckCircle, Refresh,
// //   TrendingUp, LocalShipping, CalendarToday,
// // } from "@mui/icons-material";
// // import { Bar } from "react-chartjs-2";
// // import {
// //   Chart as ChartJS, CategoryScale, LinearScale, BarElement,
// //   Title, Tooltip, Legend,
// // } from "chart.js";
// // import axiosClient from "../../configs/axios";

// // ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// // // ── Design tokens ─────────────────────────────────────────────────────────────
// // const C = {
// //   navy:      "#1B3A6B",
// //   accent:    "#2563EB",
// //   bg:        "#F0F4F8",
// //   card:      "#FFFFFF",
// //   border:    "#E2E8F0",
// //   success:   "#16A34A", successBg: "#DCFCE7",
// //   warn:      "#D97706", warnBg:    "#FEF3C7",
// //   err:       "#DC2626", errBg:     "#FEE2E2",
// //   info:      "#2563EB", infoBg:    "#EFF6FF",
// //   muted:     "#64748B",
// // };

// // const CHART_COLORS = {
// //   cylinders:  "#1B3A6B",
// //   production: "#2563EB",
// //   carbide:    "#D97706",
// //   acetone:    "#DC2626",
// //   delivered:  "#1B3A6B",
// //   empty_col:  "#D97706",
// //   sales_ret:  "#DC2626",
// //   qty_del:    "#16A34A",
// //   full:       "#16A34A",
// //   empty:      "#D97706",
// // };

// // const REFRESH_MS = 60_000;

// // // ── Period config ─────────────────────────────────────────────────────────────
// // const PERIODS = [
// //   { value: "today",  label: "Today",        days: 1  },
// //   { value: "7days",  label: "Last 7 Days",  days: 7  },
// //   { value: "30days", label: "Last 30 Days", days: 30 },
// // ];

// // // ── Helpers ───────────────────────────────────────────────────────────────────
// // const toDateKey = (v) => {
// //   if (!v) return null;
// //   const s = String(v);
// //   return s.includes("T") ? s.split("T")[0] : s.split(" ")[0];
// // };

// // const getDays = (n) =>
// //   Array.from({ length: n }, (_, i) => {
// //     const d = new Date();
// //     d.setDate(d.getDate() - (n - 1 - i));
// //     return d.toISOString().split("T")[0];
// //   });

// // const formatLabel = (iso, n) => {
// //   const d = new Date(iso);
// //   if (n === 1) return d.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" });
// //   if (n <= 7)  return d.toLocaleDateString("en-IN", { month: "short", day: "numeric" });
// //   return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
// // };

// // const groupByDay = (arr, dateField, valueFields) => {
// //   const map = new Map();
// //   arr.forEach((r) => {
// //     const key = toDateKey(r[dateField]);
// //     if (!key) return;
// //     if (!map.has(key)) {
// //       const init = {};
// //       valueFields.forEach((f) => (init[f] = 0));
// //       map.set(key, init);
// //     }
// //     const o = map.get(key);
// //     valueFields.forEach((f) => { o[f] += Number(r[f]) || 0; });
// //   });
// //   return map;
// // };

// // const chartOpts = (n) => ({
// //   responsive: true,
// //   maintainAspectRatio: false,
// //   plugins: {
// //     legend: { display: false },
// //     tooltip: { mode: "index", intersect: false },
// //   },
// //   scales: {
// //     x: {
// //       ticks: { autoSkip: n > 15, maxRotation: n > 15 ? 45 : 0, font: { size: 10 }, color: C.muted },
// //       grid: { display: false },
// //     },
// //     y: {
// //       beginAtZero: true,
// //       ticks: { font: { size: 10 }, color: C.muted },
// //       grid: { color: "rgba(0,0,0,0.04)" },
// //     },
// //   },
// // });

// // // ── Sub-components ────────────────────────────────────────────────────────────

// // const SectionCard = ({ title, icon: Icon, iconColor = C.accent, badge, loading, children, headerRight }) => (
// //   <Card elevation={0} sx={{ border: `1px solid ${C.border}`, borderRadius: "12px", bgcolor: C.card, height: "100%" }}>
// //     <CardContent sx={{ p: "18px 20px !important" }}>
// //       <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5, flexWrap: "wrap", gap: 1 }}>
// //         <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
// //           <Icon sx={{ fontSize: 16, color: iconColor }} />
// //           <Typography sx={{ fontSize: 13, fontWeight: 700, color: C.navy }}>{title}</Typography>
// //           {badge && (
// //             <Chip label={badge} size="small"
// //               sx={{ fontSize: 10, fontWeight: 600, height: 20, bgcolor: C.infoBg, color: C.info, border: "0.5px solid #BFDBFE" }}
// //             />
// //           )}
// //         </Box>
// //         {headerRight}
// //       </Box>
// //       {loading ? (
// //         <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 220 }}>
// //           <CircularProgress size={26} sx={{ color: C.accent }} />
// //         </Box>
// //       ) : children}
// //     </CardContent>
// //   </Card>
// // );

// // const LegendRow = ({ items }) => (
// //   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 1.5 }}>
// //     {items.map((l) => (
// //       <Box key={l.label} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
// //         <Box sx={{ width: 10, height: 10, borderRadius: "2px", bgcolor: l.color, flexShrink: 0 }} />
// //         <Typography sx={{ fontSize: 11, color: C.muted }}>{l.label}</Typography>
// //       </Box>
// //     ))}
// //   </Box>
// // );

// // const FilterSelect = ({ label, value, onChange, items, allLabel = "All" }) => (
// //   <FormControl size="small" sx={{ minWidth: 145 }}>
// //     <InputLabel sx={{ fontSize: 12 }}>{label}</InputLabel>
// //     <Select
// //       value={value} label={label} onChange={(e) => onChange(e.target.value)}
// //       sx={{
// //         fontSize: 12, borderRadius: "8px", bgcolor: "#F8FAFC",
// //         "& fieldset": { borderColor: C.border },
// //         "&:hover fieldset": { borderColor: C.accent },
// //         "&.Mui-focused fieldset": { borderColor: C.accent },
// //       }}
// //     >
// //       <MenuItem value=""><em>All {allLabel}</em></MenuItem>
// //       {items.map((it) => (
// //         <MenuItem key={it.value} value={String(it.value)} sx={{ fontSize: 12 }}>{it.label}</MenuItem>
// //       ))}
// //     </Select>
// //   </FormControl>
// // );

// // // BarPair removed — inventory now uses grouped bar chart

// // // ── TOGGLE STYLE (shared) ─────────────────────────────────────────────────────
// // const toggleSx = {
// //   "& .MuiToggleButton-root": {
// //     fontSize: 11, fontWeight: 500, color: C.muted,
// //     px: 1.5, py: 0.4, border: `1px solid ${C.border}`, textTransform: "none",
// //     "&.Mui-selected": { bgcolor: C.navy, color: "#fff", borderColor: C.navy, "&:hover": { bgcolor: "#122d56" } },
// //     "&:hover": { bgcolor: "#F8FAFC" },
// //   },
// // };

// // // ══════════════════════════════════════════════════════════════════════════════
// // //  MAIN COMPONENT
// // // ══════════════════════════════════════════════════════════════════════════════
// // const ManagementDashboard = () => {

// //   // ── Session ───────────────────────────────────────────────────────────────
// //   const userInfo = useMemo(() => {
// //     try {
// //       const d = JSON.parse(sessionStorage.getItem("loginUser") || "{}");
// //       return d?.result?.userInfo || {};
// //     } catch { return {}; }
// //   }, []);

// //   // ── Masters ───────────────────────────────────────────────────────────────
// //   const [plants, setPlants] = useState([]);
// //   const [depots, setDepots] = useState([]);

// //   // ── GLOBAL period ─────────────────────────────────────────────────────────
// //   const [period, setPeriod] = useState("7days");
// //   const activeDays = useMemo(() => PERIODS.find((p) => p.value === period)?.days ?? 7, [period]);

// //   // ── Per-chart filters (plant / depot selectors only) ──────────────────────
// //   const [prodPlant, setProdPlant] = useState("");
// //   const [distDepot, setDistDepot] = useState("");

// //   // ── Data states ───────────────────────────────────────────────────────────
// //   const [prodData,    setProdData]    = useState([]);
// //   const [distData,    setDistData]    = useState([]);
// //   const [invData,     setInvData]     = useState(null);
// //   const [holdingData, setHoldingData] = useState([]);

// //   const [prodLoading,    setProdLoading]    = useState(true);
// //   const [distLoading,    setDistLoading]    = useState(true);
// //   const [invLoading,     setInvLoading]     = useState(true);
// //   const [holdingLoading, setHoldingLoading] = useState(true);

// //   // ── Inventory toggle ──────────────────────────────────────────────────────
// //   const [invViewMode, setInvViewMode] = useState("plant");

// //   const [lastRefreshed, setLastRefreshed] = useState(null);
// //   const timerRef = useRef(null);

// //   // ── Fetch masters ─────────────────────────────────────────────────────────
// //   useEffect(() => {
// //     Promise.allSettled([
// //       axiosClient.get("/unit/list?page=0&size=999&searchKey="),
// //       axiosClient.get("/depot/list?page=0&size=999&searchKey="),
// //     ]).then(([pRes, dRes]) => {
// //       setPlants(pRes.status === "fulfilled"
// //         ? (Array.isArray(pRes.value.data) ? pRes.value.data : pRes.value.data?.data ?? []) : []);
// //       setDepots(dRes.status === "fulfilled"
// //         ? (Array.isArray(dRes.value.data) ? dRes.value.data : dRes.value.data?.data ?? []) : []);
// //     });
// //   }, []);

// //   // ── Date range from global period ─────────────────────────────────────────
// //   const dateRange = useMemo(() => {
// //     const toDate = new Date();
// //     const fromDate = new Date();
// //     fromDate.setDate(fromDate.getDate() - (activeDays - 1));
// //     return {
// //       from_date: fromDate.toISOString().split("T")[0],
// //       to_date:   toDate.toISOString().split("T")[0],
// //     };
// //   }, [activeDays]);

// //   // ── Fetch production ──────────────────────────────────────────────────────
// //   const fetchProduction = useCallback(async () => {
// //     setProdLoading(true);
// //     const params = { report_type: "weekly", ...dateRange };
// //     if (prodPlant) params.plant_id = prodPlant;
// //     try {
// //       const res = await axiosClient.get("/dashboard/production", { params });
// //       const raw = res.data;
// //       setProdData(Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []));
// //     } catch { setProdData([]); }
// //     finally { setProdLoading(false); }
// //   }, [dateRange, prodPlant]);

// //   // ── Fetch distribution ────────────────────────────────────────────────────
// //   const fetchDistribution = useCallback(async () => {
// //     setDistLoading(true);
// //     const params = { ...dateRange };
// //     if (distDepot) params.depot_id = distDepot;
// //     try {
// //       const res = await axiosClient.get("/dashboard/distribution", { params });
// //       const raw = res.data;
// //       setDistData(Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []));
// //     } catch { setDistData([]); }
// //     finally { setDistLoading(false); }
// //   }, [dateRange, distDepot]);

// //   // ── Fetch inventory (no date filter — always live snapshot) ───────────────
// //   const fetchInventory = useCallback(async () => {
// //     setInvLoading(true);
// //     try {
// //       const res = await axiosClient.get("/dashboard/inventory");
// //       setInvData(res.data || null);
// //     } catch { setInvData(null); }
// //     finally { setInvLoading(false); }
// //   }, []);

// //   // ── Fetch holding ─────────────────────────────────────────────────────────
// //   const fetchHolding = useCallback(async () => {
// //     setHoldingLoading(true);
// //     try {
// //       const res = await axiosClient.get("/reports/EmptyCylinderHolding?page=0&size=999&searchKey=");
// //       const raw = res.data;
// //       setHoldingData(Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []));
// //     } catch { setHoldingData([]); }
// //     finally { setHoldingLoading(false); }
// //   }, []);

// //   // ── Re-fetch time-sensitive charts when period/filters change ─────────────
// //   useEffect(() => { fetchProduction(); }, [fetchProduction]);
// //   useEffect(() => { fetchDistribution(); }, [fetchDistribution]);

// //   // ── Full refresh (mount + polling) ────────────────────────────────────────
// //   const fetchAll = useCallback(() => {
// //     fetchProduction();
// //     fetchDistribution();
// //     fetchInventory();
// //     fetchHolding();
// //     setLastRefreshed(new Date());
// //   }, [fetchProduction, fetchDistribution, fetchInventory, fetchHolding]);

// //   useEffect(() => {
// //     fetchInventory();
// //     fetchHolding();
// //     setLastRefreshed(new Date());
// //     if (timerRef.current) clearInterval(timerRef.current);
// //     timerRef.current = setInterval(fetchAll, REFRESH_MS);
// //     return () => clearInterval(timerRef.current);
// //   }, []); // eslint-disable-line

// //   // ── Production chart ──────────────────────────────────────────────────────
// //   const prodChartData = useMemo(() => {
// //     const dateKeys = getDays(activeDays);
// //     const map = groupByDay(prodData, "entry_date", ["cylinder_count", "total_qty_filled", "carbide", "acetone"]);
// //     return {
// //       labels: dateKeys.map((d) => formatLabel(d, activeDays)),
// //       datasets: [
// //         { label: "Cylinders Filled",  data: dateKeys.map((d) => map.get(d)?.cylinder_count ?? 0),                       backgroundColor: CHART_COLORS.cylinders,  borderRadius: 3, barPercentage: 0.7 },
// //         { label: "Production (KG)",   data: dateKeys.map((d) => +(map.get(d)?.total_qty_filled ?? 0).toFixed(1)),        backgroundColor: CHART_COLORS.production, borderRadius: 3, barPercentage: 0.7 },
// //         { label: "Carbide Used (KG)", data: dateKeys.map((d) => +(map.get(d)?.carbide ?? 0).toFixed(1)),                 backgroundColor: CHART_COLORS.carbide,    borderRadius: 3, barPercentage: 0.7 },
// //         { label: "Acetone Used (KG)", data: dateKeys.map((d) => +(map.get(d)?.acetone ?? 0).toFixed(1)),                 backgroundColor: CHART_COLORS.acetone,    borderRadius: 3, barPercentage: 0.7 },
// //       ],
// //     };
// //   }, [prodData, activeDays]);

// //   // ── Distribution chart ────────────────────────────────────────────────────
// //   const distChartData = useMemo(() => {
// //     const dateKeys = getDays(activeDays);
// //     const map = groupByDay(distData, "entry_date", ["delivered_cylinders", "empty_cylinders_collected", "sales_return_cylinders", "total_qty_delivered"]);
// //     return {
// //       labels: dateKeys.map((d) => formatLabel(d, activeDays)),
// //       datasets: [
// //         { label: "Delivered Cylinders",    data: dateKeys.map((d) => map.get(d)?.delivered_cylinders       ?? 0), backgroundColor: CHART_COLORS.delivered, borderRadius: 3, barPercentage: 0.7 },
// //         { label: "Empty Cyls Collected",   data: dateKeys.map((d) => map.get(d)?.empty_cylinders_collected ?? 0), backgroundColor: CHART_COLORS.empty_col, borderRadius: 3, barPercentage: 0.7 },
// //         { label: "Sales Return Cylinders", data: dateKeys.map((d) => map.get(d)?.sales_return_cylinders    ?? 0), backgroundColor: CHART_COLORS.sales_ret, borderRadius: 3, barPercentage: 0.7 },
// //         { label: "Total Qty Delivered",    data: dateKeys.map((d) => map.get(d)?.total_qty_delivered       ?? 0), backgroundColor: CHART_COLORS.qty_del,   borderRadius: 3, barPercentage: 0.7 },
// //       ],
// //     };
// //   }, [distData, activeDays]);

// //   // ── Inventory grouped bar chart (Full + Empty side-by-side per plant/depot) ──
// //   const invChartData = useMemo(() => {
// //     if (!invData) return null;
// //     let rows = [];
// //     if (invViewMode === "plant") {
// //       const r = invData.plant_wise ?? invData.plants ?? [];
// //       rows = r.length > 0
// //         ? r.map((x) => ({ label: x.plant_name || x.name || "Plant", full: Number(x.full ?? x.full_count ?? 0), empty: Number(x.empty ?? x.empty_count ?? 0) }))
// //         : [{ label: "All Plants", full: invData.full?.tgpl || 0, empty: invData.empty?.tgpl || 0 }];
// //     } else {
// //       const r = invData.depot_wise ?? invData.depots ?? [];
// //       rows = r.length > 0
// //         ? r.map((x) => ({ label: x.depot_name || x.name || "Depot", full: Number(x.full ?? x.full_count ?? 0), empty: Number(x.empty ?? x.empty_count ?? 0) }))
// //         : [{ label: "All Depots", full: invData.full?.customer || 0, empty: invData.empty?.customer || 0 }];
// //     }
// //     return {
// //       labels: rows.map((r) => r.label),
// //       datasets: [
// //         { label: "Full Cylinders",  data: rows.map((r) => r.full),  backgroundColor: CHART_COLORS.full,  borderRadius: 4, barPercentage: 0.65, categoryPercentage: 0.7 },
// //         { label: "Empty Cylinders", data: rows.map((r) => r.empty), backgroundColor: CHART_COLORS.empty, borderRadius: 4, barPercentage: 0.65, categoryPercentage: 0.7 },
// //       ],
// //     };
// //   }, [invData, invViewMode]);

// //   // ── Holding chart ─────────────────────────────────────────────────────────
// //   const holdingChartData = useMemo(() => {
// //     const top10 = [...holdingData]
// //       .sort((a, b) => (b.total_cylinders || 0) - (a.total_cylinders || 0))
// //       .slice(0, 10);
// //     return {
// //       labels: top10.map((r) => r.customer_name || "Unknown"),
// //       datasets: [{
// //         label: "Cylinders Held",
// //         data: top10.map((r) => Number(r.total_cylinders || 0)),
// //         backgroundColor: CHART_COLORS.cylinders,
// //         borderRadius: 4,
// //         barPercentage: 0.65,
// //       }],
// //     };
// //   }, [holdingData]);

// //   // ── Render ────────────────────────────────────────────────────────────────
// //   return (
// //     <Box sx={{ p: { xs: "12px", sm: "16px", md: "20px" }, bgcolor: C.bg, minHeight: "100vh" }}>

// //       {/* ══ HEADER ══ */}
// //       <Box sx={{
// //         display: "flex", alignItems: "center", justifyContent: "space-between",
// //         flexWrap: "wrap", gap: 2, mb: 2.5,
// //       }}>
// //         {/* Left: title */}
// //         <Box>
// //           <Typography sx={{ fontSize: 18, fontWeight: 700, color: C.navy }}>Management Dashboard</Typography>
// //           <Typography sx={{ fontSize: 12, color: C.muted, mt: 0.3 }}>
// //             Production · Distribution · Inventory · Customer Holding
// //           </Typography>
// //         </Box>

// //         {/* Right: global period toggle + meta */}
// //         <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>

// //           {/* ── GLOBAL PERIOD TOGGLE ── */}
// //           <Box sx={{
// //             display: "flex", alignItems: "center", gap: 1,
// //             bgcolor: C.card, border: `1px solid ${C.border}`,
// //             borderRadius: "10px", px: 1.5, py: 0.75,
// //           }}>
// //             <CalendarToday sx={{ fontSize: 14, color: C.muted }} />
// //             <Typography sx={{ fontSize: 11, color: C.muted, fontWeight: 600, mr: 0.5 }}>Period:</Typography>
// //             <ToggleButtonGroup
// //               value={period}
// //               exclusive
// //               onChange={(_, v) => v && setPeriod(v)}
// //               size="small"
// //               sx={toggleSx}
// //             >
// //               {PERIODS.map((p) => (
// //                 <ToggleButton key={p.value} value={p.value}>{p.label}</ToggleButton>
// //               ))}
// //             </ToggleButtonGroup>
// //           </Box>

// //           {lastRefreshed && (
// //             <Typography sx={{ fontSize: 11, color: C.muted }}>
// //               Updated {lastRefreshed.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}
// //             </Typography>
// //           )}
// //           <Chip
// //             label="Management" size="small"
// //             icon={<CheckCircle sx={{ fontSize: "13px !important", color: `${C.info} !important` }} />}
// //             sx={{ bgcolor: C.infoBg, color: C.info, border: "0.5px solid #BFDBFE", fontSize: 11, fontWeight: 500 }}
// //           />
// //           <Box component="span" onClick={fetchAll} title="Refresh now"
// //             sx={{ cursor: "pointer", color: C.muted, display: "flex", alignItems: "center", "&:hover": { color: C.accent } }}>
// //             <Refresh sx={{ fontSize: 18 }} />
// //           </Box>
// //         </Box>
// //       </Box>

// //       <Grid container spacing={2}>

// //         {/* ══ ROW 1: Production + Distribution ══ */}

// //         {/* Production Summary */}
// //         <Grid item xs={12} lg={6}>
// //           <SectionCard
// //             title="Production Summary"
// //             icon={Factory}
// //             iconColor={C.warn}
// //             loading={prodLoading}
// //             headerRight={
// //               <FilterSelect
// //                 label="Plant" value={prodPlant} onChange={setProdPlant} allLabel="Plants"
// //                 items={plants.map((p) => ({ value: p.plant_id, label: p.plant_name }))}
// //               />
// //             }
// //           >
// //             <LegendRow items={[
// //               { label: "Cylinders Filled",  color: CHART_COLORS.cylinders  },
// //               { label: "Production (KG)",   color: CHART_COLORS.production },
// //               { label: "Carbide Used (KG)", color: CHART_COLORS.carbide    },
// //               { label: "Acetone Used (KG)", color: CHART_COLORS.acetone    },
// //             ]} />
// //             <Box sx={{ position: "relative", height: { xs: 220, sm: 250 } }}>
// //               <Bar data={prodChartData} options={chartOpts(activeDays)} />
// //             </Box>
// //           </SectionCard>
// //         </Grid>

// //         {/* Distribution Summary */}
// //         <Grid item xs={12} lg={6}>
// //           <SectionCard
// //             title="Distribution Summary"
// //             icon={LocalShipping}
// //             iconColor={C.accent}
// //             loading={distLoading}
// //             headerRight={
// //               <FilterSelect
// //                 label="Depot" value={distDepot} onChange={setDistDepot} allLabel="Depots"
// //                 items={depots.map((d) => ({ value: d.depot_id, label: d.depot_name }))}
// //               />
// //             }
// //           >
// //             <LegendRow items={[
// //               { label: "Delivered Cylinders",    color: CHART_COLORS.delivered  },
// //               { label: "Empty Cyls Collected",   color: CHART_COLORS.empty_col  },
// //               { label: "Sales Return Cylinders", color: CHART_COLORS.sales_ret  },
// //               { label: "Total Qty Delivered",    color: CHART_COLORS.qty_del    },
// //             ]} />
// //             <Box sx={{ position: "relative", height: { xs: 220, sm: 250 } }}>
// //               <Bar data={distChartData} options={chartOpts(activeDays)} />
// //             </Box>
// //           </SectionCard>
// //         </Grid>

// //         {/* ══ ROW 2: Inventory + Customer Holding ══ */}

// //         {/* Inventory — Full & Empty pair bars */}
// //         <Grid item xs={12} lg={6}>
// //           <SectionCard
// //             title="Inventory — Full & Empty"
// //             icon={Warehouse}
// //             iconColor="#0891B2"
// //             badge="Live"
// //             loading={invLoading}
// //             headerRight={
// //               <ToggleButtonGroup
// //                 value={invViewMode} exclusive onChange={(_, v) => v && setInvViewMode(v)}
// //                 size="small" sx={toggleSx}
// //               >
// //                 <ToggleButton value="plant">Plant Wise</ToggleButton>
// //                 <ToggleButton value="depot">Depot Wise</ToggleButton>
// //               </ToggleButtonGroup>
// //             }
// //           >
// //             <LegendRow items={[
// //               { label: "Full Cylinders",  color: CHART_COLORS.full  },
// //               { label: "Empty Cylinders", color: CHART_COLORS.empty },
// //             ]} />
// //             {!invChartData ? (
// //               <Typography sx={{ fontSize: 13, color: C.muted, py: 2 }}>No inventory data available.</Typography>
// //             ) : (
// //               <Box sx={{ position: "relative", height: { xs: 220, sm: 250 } }}>
// //                 <Bar
// //                   data={invChartData}
// //                   options={{
// //                     ...chartOpts(invChartData.labels.length),
// //                     scales: {
// //                       ...chartOpts(invChartData.labels.length).scales,
// //                       x: {
// //                         ...chartOpts(invChartData.labels.length).scales.x,
// //                         ticks: {
// //                           ...chartOpts(invChartData.labels.length).scales.x.ticks,
// //                           maxRotation: invChartData.labels.length > 4 ? 35 : 0,
// //                           autoSkip: false,
// //                         },
// //                       },
// //                     },
// //                   }}
// //                 />
// //               </Box>
// //             )}
// //           </SectionCard>
// //         </Grid>

// //         {/* Customer Holding */}
// //         <Grid item xs={12} lg={6}>
// //           <SectionCard
// //             title="Customer Holding"
// //             icon={TrendingUp}
// //             iconColor={C.warn}
// //             badge="Top 10"
// //             loading={holdingLoading}
// //           >
// //             {holdingData.length === 0 ? (
// //               <Typography sx={{ fontSize: 13, color: C.muted, py: 2 }}>No holding data available.</Typography>
// //             ) : (
// //               <>
// //                 <LegendRow items={[{ label: "Cylinders Held", color: CHART_COLORS.cylinders }]} />
// //                 <Box sx={{ position: "relative", height: { xs: 220, sm: 250 } }}>
// //                   <Bar
// //                     data={holdingChartData}
// //                     options={{
// //                       ...chartOpts(10),
// //                       scales: {
// //                         ...chartOpts(10).scales,
// //                         x: { ...chartOpts(10).scales.x, ticks: { ...chartOpts(10).scales.x.ticks, maxRotation: 35, autoSkip: false } },
// //                       },
// //                     }}
// //                   />
// //                 </Box>
// //               </>
// //             )}
// //           </SectionCard>
// //         </Grid>

// //       </Grid>
// //     </Box>
// //   );
// // };

// // export default ManagementDashboard;


// import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
// import {
//   Box, Grid, Card, CardContent, Typography, CircularProgress,
//   Chip, ToggleButtonGroup, ToggleButton, FormControl,
//   InputLabel, Select, MenuItem,
// } from "@mui/material";
// import {
//   Factory, Warehouse, CheckCircle, Refresh,
//   TrendingUp, LocalShipping, CalendarToday,
// } from "@mui/icons-material";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS, CategoryScale, LinearScale, BarElement,
//   Title, Tooltip, Legend,
// } from "chart.js";
// import axiosClient from "../../configs/axios";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// // ── Design tokens ─────────────────────────────────────────────────────────────
// const C = {
//   navy:      "#1B3A6B",
//   accent:    "#2563EB",
//   bg:        "#F0F4F8",
//   card:      "#FFFFFF",
//   border:    "#E2E8F0",
//   success:   "#16A34A", successBg: "#DCFCE7",
//   warn:      "#D97706", warnBg:    "#FEF3C7",
//   err:       "#DC2626", errBg:     "#FEE2E2",
//   info:      "#2563EB", infoBg:    "#EFF6FF",
//   muted:     "#64748B",
// };

// const CHART_COLORS = {
//   cylinders:  "#1B3A6B",
//   production: "#2563EB",
//   carbide:    "#D97706",
//   acetone:    "#DC2626",
//   delivered:  "#1B3A6B",
//   empty_col:  "#D97706",
//   sales_ret:  "#DC2626",
//   qty_del:    "#16A34A",
//   full:       "#16A34A",
//   empty:      "#D97706",
// };

// const REFRESH_MS = 60_000;

// // ── Period config ─────────────────────────────────────────────────────────────
// const PERIODS = [
//   { value: "today",  label: "Today",        days: 1  },
//   { value: "7days",  label: "Last 7 Days",  days: 7  },
//   { value: "30days", label: "Last 30 Days", days: 30 },
// ];

// // ── Customer Holding age-bucket config ─────────────────────────────────────────
// // Buckets represent "how many days has the cylinder been with the customer"
// // based on (today - last transaction/delivery date i.e. dc_date)
// const HOLDING_BUCKETS = [
//   { key: "0-7",   label: "0-7 Days",   min: 0,  max: 7   },
//   { key: "8-15",  label: "8-15 Days",  min: 8,  max: 15  },
//   { key: "16-30", label: "16-30 Days", min: 16, max: 30  },
//   { key: "31-45", label: "31-45 Days", min: 31, max: 45  },
//   { key: "46-60", label: "46-60 Days", min: 46, max: 60  },
//   { key: "60+",   label: "60+ Days",   min: 61, max: Infinity },
// ];

// const HOLDING_BUCKET_COLORS = {
//   "0-7":   "#16A34A",
//   "8-15":  "#2563EB",
//   "16-30": "#D97706",
//   "31-45": "#EA580C",
//   "46-60": "#DC2626",
//   "60+":   "#7F1D1D",
// };

// // ── Helpers ───────────────────────────────────────────────────────────────────
// const toDateKey = (v) => {
//   if (!v) return null;
//   const s = String(v);
//   return s.includes("T") ? s.split("T")[0] : s.split(" ")[0];
// };

// const getDays = (n) =>
//   Array.from({ length: n }, (_, i) => {
//     const d = new Date();
//     d.setDate(d.getDate() - (n - 1 - i));
//     return d.toISOString().split("T")[0];
//   });

// const formatLabel = (iso, n) => {
//   const d = new Date(iso);
//   if (n === 1) return d.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" });
//   if (n <= 7)  return d.toLocaleDateString("en-IN", { month: "short", day: "numeric" });
//   return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
// };

// const groupByDay = (arr, dateField, valueFields) => {
//   const map = new Map();
//   arr.forEach((r) => {
//     const key = toDateKey(r[dateField]);
//     if (!key) return;
//     if (!map.has(key)) {
//       const init = {};
//       valueFields.forEach((f) => (init[f] = 0));
//       map.set(key, init);
//     }
//     const o = map.get(key);
//     valueFields.forEach((f) => { o[f] += Number(r[f]) || 0; });
//   });
//   return map;
// };

// // Days between dc_date (last transaction/delivery date) and today
// const daysHeld = (dcDate) => {
//   if (!dcDate) return null;
//   const key = toDateKey(dcDate);
//   const d = new Date(key);
//   if (isNaN(d.getTime())) return null;
//   const today = new Date();
//   today.setHours(0, 0, 0, 0);
//   d.setHours(0, 0, 0, 0);
//   const diffMs = today.getTime() - d.getTime();
//   return Math.floor(diffMs / (1000 * 60 * 60 * 24));
// };

// const bucketForDays = (days) => {
//   if (days == null) return null;
//   return HOLDING_BUCKETS.find((b) => days >= b.min && days <= b.max)?.key ?? null;
// };

// const chartOpts = (n) => ({
//   responsive: true,
//   maintainAspectRatio: false,
//   plugins: {
//     legend: { display: false },
//     tooltip: { mode: "index", intersect: false },
//   },
//   scales: {
//     x: {
//       ticks: { autoSkip: n > 15, maxRotation: n > 15 ? 45 : 0, font: { size: 10 }, color: C.muted },
//       grid: { display: false },
//     },
//     y: {
//       beginAtZero: true,
//       ticks: { font: { size: 10 }, color: C.muted },
//       grid: { color: "rgba(0,0,0,0.04)" },
//     },
//   },
// });

// // Horizontal bar options for Customer Holding (age buckets)
// const holdingChartOpts = {
//   indexAxis: "y",
//   responsive: true,
//   maintainAspectRatio: false,
//   plugins: {
//     legend: { display: false },
//     tooltip: {
//       mode: "index",
//       intersect: false,
//       callbacks: {
//         label: (ctx) => `${ctx.parsed.x} cylinder${ctx.parsed.x === 1 ? "" : "s"}`,
//       },
//     },
//   },
//   scales: {
//     x: {
//       beginAtZero: true,
//       ticks: { precision: 0, font: { size: 10 }, color: C.muted },
//       grid: { color: "rgba(0,0,0,0.04)" },
//     },
//     y: {
//       ticks: { font: { size: 11, weight: 600 }, color: C.navy },
//       grid: { display: false },
//     },
//   },
// };

// // ── Sub-components ────────────────────────────────────────────────────────────

// const SectionCard = ({ title, icon: Icon, iconColor = C.accent, badge, loading, children, headerRight }) => (
//   <Card elevation={0} sx={{ border: `1px solid ${C.border}`, borderRadius: "12px", bgcolor: C.card, height: "100%" }}>
//     <CardContent sx={{ p: "18px 20px !important" }}>
//       <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5, flexWrap: "wrap", gap: 1 }}>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
//           <Icon sx={{ fontSize: 16, color: iconColor }} />
//           <Typography sx={{ fontSize: 13, fontWeight: 700, color: C.navy }}>{title}</Typography>
//           {badge && (
//             <Chip label={badge} size="small"
//               sx={{ fontSize: 10, fontWeight: 600, height: 20, bgcolor: C.infoBg, color: C.info, border: "0.5px solid #BFDBFE" }}
//             />
//           )}
//         </Box>
//         {headerRight}
//       </Box>
//       {loading ? (
//         <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 220 }}>
//           <CircularProgress size={26} sx={{ color: C.accent }} />
//         </Box>
//       ) : children}
//     </CardContent>
//   </Card>
// );

// const LegendRow = ({ items }) => (
//   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 1.5 }}>
//     {items.map((l) => (
//       <Box key={l.label} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//         <Box sx={{ width: 10, height: 10, borderRadius: "2px", bgcolor: l.color, flexShrink: 0 }} />
//         <Typography sx={{ fontSize: 11, color: C.muted }}>{l.label}</Typography>
//       </Box>
//     ))}
//   </Box>
// );

// const FilterSelect = ({ label, value, onChange, items, allLabel = "All" }) => (
//   <FormControl size="small" sx={{ minWidth: 145 }}>
//     <InputLabel sx={{ fontSize: 12 }}>{label}</InputLabel>
//     <Select
//       value={value} label={label} onChange={(e) => onChange(e.target.value)}
//       sx={{
//         fontSize: 12, borderRadius: "8px", bgcolor: "#F8FAFC",
//         "& fieldset": { borderColor: C.border },
//         "&:hover fieldset": { borderColor: C.accent },
//         "&.Mui-focused fieldset": { borderColor: C.accent },
//       }}
//     >
//       <MenuItem value=""><em>All {allLabel}</em></MenuItem>
//       {items.map((it) => (
//         <MenuItem key={it.value} value={String(it.value)} sx={{ fontSize: 12 }}>{it.label}</MenuItem>
//       ))}
//     </Select>
//   </FormControl>
// );

// // ── TOGGLE STYLE (shared) ─────────────────────────────────────────────────────
// const toggleSx = {
//   "& .MuiToggleButton-root": {
//     fontSize: 11, fontWeight: 500, color: C.muted,
//     px: 1.5, py: 0.4, border: `1px solid ${C.border}`, textTransform: "none",
//     "&.Mui-selected": { bgcolor: C.navy, color: "#fff", borderColor: C.navy, "&:hover": { bgcolor: "#122d56" } },
//     "&:hover": { bgcolor: "#F8FAFC" },
//   },
// };

// // ══════════════════════════════════════════════════════════════════════════════
// //  MAIN COMPONENT
// // ══════════════════════════════════════════════════════════════════════════════
// const ManagementDashboard = () => {

//   // ── Session ───────────────────────────────────────────────────────────────
//   const userInfo = useMemo(() => {
//     try {
//       const d = JSON.parse(sessionStorage.getItem("loginUser") || "{}");
//       return d?.result?.userInfo || {};
//     } catch { return {}; }
//   }, []);

//   // ── Masters ───────────────────────────────────────────────────────────────
//   const [plants, setPlants] = useState([]);
//   const [depots, setDepots] = useState([]);

//   // ── GLOBAL period ─────────────────────────────────────────────────────────
//   const [period, setPeriod] = useState("7days");
//   const activeDays = useMemo(() => PERIODS.find((p) => p.value === period)?.days ?? 7, [period]);

//   // ── Per-chart filters (plant / depot selectors only) ──────────────────────
//   const [prodPlant, setProdPlant] = useState("");
//   const [distDepot, setDistDepot] = useState("");

//   // ── Data states ───────────────────────────────────────────────────────────
//   const [prodData,    setProdData]    = useState([]);
//   const [distData,    setDistData]    = useState([]);
//   const [invData,     setInvData]     = useState(null);
//   const [holdingData, setHoldingData] = useState([]);

//   const [prodLoading,    setProdLoading]    = useState(true);
//   const [distLoading,    setDistLoading]    = useState(true);
//   const [invLoading,     setInvLoading]     = useState(true);
//   const [holdingLoading, setHoldingLoading] = useState(true);

//   // ── Inventory toggle ──────────────────────────────────────────────────────
//   const [invViewMode, setInvViewMode] = useState("plant");

//   const [lastRefreshed, setLastRefreshed] = useState(null);
//   const timerRef = useRef(null);

//   // ── Fetch masters ─────────────────────────────────────────────────────────
//   useEffect(() => {
//     Promise.allSettled([
//       axiosClient.get("/unit/list?page=0&size=999&searchKey="),
//       axiosClient.get("/depot/list?page=0&size=999&searchKey="),
//     ]).then(([pRes, dRes]) => {
//       setPlants(pRes.status === "fulfilled"
//         ? (Array.isArray(pRes.value.data) ? pRes.value.data : pRes.value.data?.data ?? []) : []);
//       setDepots(dRes.status === "fulfilled"
//         ? (Array.isArray(dRes.value.data) ? dRes.value.data : dRes.value.data?.data ?? []) : []);
//     });
//   }, []);

//   // ── Date range from global period ─────────────────────────────────────────
//   const dateRange = useMemo(() => {
//     const toDate = new Date();
//     const fromDate = new Date();
//     fromDate.setDate(fromDate.getDate() - (activeDays - 1));
//     return {
//       from_date: fromDate.toISOString().split("T")[0],
//       to_date:   toDate.toISOString().split("T")[0],
//     };
//   }, [activeDays]);

//   // ── Fetch production ──────────────────────────────────────────────────────
//   const fetchProduction = useCallback(async () => {
//     setProdLoading(true);
//     const params = { report_type: "weekly", ...dateRange };
//     if (prodPlant) params.plant_id = prodPlant;
//     try {
//       const res = await axiosClient.get("/dashboard/production", { params });
//       const raw = res.data;
//       setProdData(Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []));
//     } catch { setProdData([]); }
//     finally { setProdLoading(false); }
//   }, [dateRange, prodPlant]);

//   // ── Fetch distribution ────────────────────────────────────────────────────
//   const fetchDistribution = useCallback(async () => {
//     setDistLoading(true);
//     const params = { ...dateRange };
//     if (distDepot) params.depot_id = distDepot;
//     try {
//       const res = await axiosClient.get("/dashboard/distribution", { params });
//       const raw = res.data;
//       setDistData(Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []));
//     } catch { setDistData([]); }
//     finally { setDistLoading(false); }
//   }, [dateRange, distDepot]);

//   // ── Fetch inventory (no date filter — always live snapshot) ───────────────
//   const fetchInventory = useCallback(async () => {
//     setInvLoading(true);
//     try {
//       const res = await axiosClient.get("/dashboard/inventory");
//       setInvData(res.data || null);
//     } catch { setInvData(null); }
//     finally { setInvLoading(false); }
//   }, []);

//   // ── Fetch holding ─────────────────────────────────────────────────────────
//   const fetchHolding = useCallback(async () => {
//     setHoldingLoading(true);
//     try {
//       const res = await axiosClient.get("/reports/EmptyCylinderHolding?page=0&size=999&searchKey=");
//       const raw = res.data;
//       setHoldingData(Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []));
//     } catch { setHoldingData([]); }
//     finally { setHoldingLoading(false); }
//   }, []);

//   // ── Re-fetch time-sensitive charts when period/filters change ─────────────
//   useEffect(() => { fetchProduction(); }, [fetchProduction]);
//   useEffect(() => { fetchDistribution(); }, [fetchDistribution]);

//   // ── Full refresh (mount + polling) ────────────────────────────────────────
//   const fetchAll = useCallback(() => {
//     fetchProduction();
//     fetchDistribution();
//     fetchInventory();
//     fetchHolding();
//     setLastRefreshed(new Date());
//   }, [fetchProduction, fetchDistribution, fetchInventory, fetchHolding]);

//   useEffect(() => {
//     fetchInventory();
//     fetchHolding();
//     setLastRefreshed(new Date());
//     if (timerRef.current) clearInterval(timerRef.current);
//     timerRef.current = setInterval(fetchAll, REFRESH_MS);
//     return () => clearInterval(timerRef.current);
//   }, []); // eslint-disable-line

//   // ── Production chart ──────────────────────────────────────────────────────
//   const prodChartData = useMemo(() => {
//     const dateKeys = getDays(activeDays);
//     const map = groupByDay(prodData, "entry_date", ["cylinder_count", "total_qty_filled", "carbide", "acetone"]);
//     return {
//       labels: dateKeys.map((d) => formatLabel(d, activeDays)),
//       datasets: [
//         { label: "Cylinders Filled",  data: dateKeys.map((d) => map.get(d)?.cylinder_count ?? 0),                       backgroundColor: CHART_COLORS.cylinders,  borderRadius: 3, barPercentage: 0.7 },
//         { label: "Production (KG)",   data: dateKeys.map((d) => +(map.get(d)?.total_qty_filled ?? 0).toFixed(1)),        backgroundColor: CHART_COLORS.production, borderRadius: 3, barPercentage: 0.7 },
//         { label: "Carbide Used (KG)", data: dateKeys.map((d) => +(map.get(d)?.carbide ?? 0).toFixed(1)),                 backgroundColor: CHART_COLORS.carbide,    borderRadius: 3, barPercentage: 0.7 },
//         { label: "Acetone Used (KG)", data: dateKeys.map((d) => +(map.get(d)?.acetone ?? 0).toFixed(1)),                 backgroundColor: CHART_COLORS.acetone,    borderRadius: 3, barPercentage: 0.7 },
//       ],
//     };
//   }, [prodData, activeDays]);

//   // ── Distribution chart ────────────────────────────────────────────────────
//   const distChartData = useMemo(() => {
//     const dateKeys = getDays(activeDays);
//     const map = groupByDay(distData, "entry_date", ["delivered_cylinders", "empty_cylinders_collected", "sales_return_cylinders", "total_qty_delivered"]);
//     return {
//       labels: dateKeys.map((d) => formatLabel(d, activeDays)),
//       datasets: [
//         { label: "Delivered Cylinders",    data: dateKeys.map((d) => map.get(d)?.delivered_cylinders       ?? 0), backgroundColor: CHART_COLORS.delivered, borderRadius: 3, barPercentage: 0.7 },
//         { label: "Empty Cyls Collected",   data: dateKeys.map((d) => map.get(d)?.empty_cylinders_collected ?? 0), backgroundColor: CHART_COLORS.empty_col, borderRadius: 3, barPercentage: 0.7 },
//         { label: "Sales Return Cylinders", data: dateKeys.map((d) => map.get(d)?.sales_return_cylinders    ?? 0), backgroundColor: CHART_COLORS.sales_ret, borderRadius: 3, barPercentage: 0.7 },
//         { label: "Total Qty Delivered",    data: dateKeys.map((d) => map.get(d)?.total_qty_delivered       ?? 0), backgroundColor: CHART_COLORS.qty_del,   borderRadius: 3, barPercentage: 0.7 },
//       ],
//     };
//   }, [distData, activeDays]);

//   // ── Inventory grouped bar chart (Full + Empty side-by-side per plant/depot) ──
//   const invChartData = useMemo(() => {
//     if (!invData) return null;
//     let rows = [];
//     if (invViewMode === "plant") {
//       const r = invData.plant_wise ?? invData.plants ?? [];
//       rows = r.length > 0
//         ? r.map((x) => ({ label: x.plant_name || x.name || "Plant", full: Number(x.full ?? x.full_count ?? 0), empty: Number(x.empty ?? x.empty_count ?? 0) }))
//         : [{ label: "All Plants", full: invData.full?.tgpl || 0, empty: invData.empty?.tgpl || 0 }];
//     } else {
//       const r = invData.depot_wise ?? invData.depots ?? [];
//       rows = r.length > 0
//         ? r.map((x) => ({ label: x.depot_name || x.name || "Depot", full: Number(x.full ?? x.full_count ?? 0), empty: Number(x.empty ?? x.empty_count ?? 0) }))
//         : [{ label: "All Depots", full: invData.full?.customer || 0, empty: invData.empty?.customer || 0 }];
//     }
//     return {
//       labels: rows.map((r) => r.label),
//       datasets: [
//         { label: "Full Cylinders",  data: rows.map((r) => r.full),  backgroundColor: CHART_COLORS.full,  borderRadius: 4, barPercentage: 0.65, categoryPercentage: 0.7 },
//         { label: "Empty Cylinders", data: rows.map((r) => r.empty), backgroundColor: CHART_COLORS.empty, borderRadius: 4, barPercentage: 0.65, categoryPercentage: 0.7 },
//       ],
//     };
//   }, [invData, invViewMode]);

//   // ── Customer Holding: bucket cylinders by "days held" ─────────────────────
//   // For every row (customer + product), each entry in `row.cylinders` has a
//   // `dc_date` (last delivery / transaction date). The number of days the
//   // cylinder has been with the customer = today - dc_date.
//   // If a row has no per-cylinder breakdown, fall back to row-level
//   // `dc_date` / `last_transaction_date` applied to `total_cylinders`.
//   const holdingBucketTotals = useMemo(() => {
//     const totals = {};
//     HOLDING_BUCKETS.forEach((b) => { totals[b.key] = 0; });

//     holdingData.forEach((row) => {
//       const cylinders = Array.isArray(row.cylinders) ? row.cylinders : null;

//       if (cylinders && cylinders.length > 0) {
//         cylinders.forEach((cyl) => {
//           const d = daysHeld(cyl.dc_date || cyl.delivery_date || cyl.last_transaction_date);
//           const bucket = bucketForDays(d);
//           if (bucket) totals[bucket] += 1;
//         });
//       } else {
//         // Fallback: use row-level last transaction date for the whole quantity
//         const d = daysHeld(row.dc_date || row.delivery_date || row.last_transaction_date);
//         const bucket = bucketForDays(d);
//         const qty = Number(row.total_cylinders || 0);
//         if (bucket) totals[bucket] += qty;
//       }
//     });

//     return totals;
//   }, [holdingData]);

//   const holdingChartData = useMemo(() => {
//     return {
//       labels: HOLDING_BUCKETS.map((b) => b.label),
//       datasets: [{
//         label: "Cylinders Held",
//         data: HOLDING_BUCKETS.map((b) => holdingBucketTotals[b.key] ?? 0),
//         backgroundColor: HOLDING_BUCKETS.map((b) => HOLDING_BUCKET_COLORS[b.key]),
//         borderRadius: 4,
//         barThickness: 22,
//       }],
//     };
//   }, [holdingBucketTotals]);

//   const holdingHasData = useMemo(
//     () => Object.values(holdingBucketTotals).some((v) => v > 0),
//     [holdingBucketTotals]
//   );

//   // ── Render ────────────────────────────────────────────────────────────────
//   return (
//     <Box sx={{ p: { xs: "12px", sm: "16px", md: "20px" }, bgcolor: C.bg, minHeight: "100vh" }}>

//       {/* ══ HEADER ══ */}
//       <Box sx={{
//         display: "flex", alignItems: "center", justifyContent: "space-between",
//         flexWrap: "wrap", gap: 2, mb: 2.5,
//       }}>
//         {/* Left: title */}
//         <Box>
//           <Typography sx={{ fontSize: 18, fontWeight: 700, color: C.navy }}>Management Dashboard</Typography>
//           <Typography sx={{ fontSize: 12, color: C.muted, mt: 0.3 }}>
//             Production · Distribution · Inventory · Customer Holding
//           </Typography>
//         </Box>

//         {/* Right: global period toggle + meta */}
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>

//           {/* ── GLOBAL PERIOD TOGGLE ── */}
//           <Box sx={{
//             display: "flex", alignItems: "center", gap: 1,
//             bgcolor: C.card, border: `1px solid ${C.border}`,
//             borderRadius: "10px", px: 1.5, py: 0.75,
//           }}>
//             <CalendarToday sx={{ fontSize: 14, color: C.muted }} />
//             <Typography sx={{ fontSize: 11, color: C.muted, fontWeight: 600, mr: 0.5 }}>Period:</Typography>
//             <ToggleButtonGroup
//               value={period}
//               exclusive
//               onChange={(_, v) => v && setPeriod(v)}
//               size="small"
//               sx={toggleSx}
//             >
//               {PERIODS.map((p) => (
//                 <ToggleButton key={p.value} value={p.value}>{p.label}</ToggleButton>
//               ))}
//             </ToggleButtonGroup>
//           </Box>

//           {lastRefreshed && (
//             <Typography sx={{ fontSize: 11, color: C.muted }}>
//               Updated {lastRefreshed.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}
//             </Typography>
//           )}
//           <Chip
//             label="Management" size="small"
//             icon={<CheckCircle sx={{ fontSize: "13px !important", color: `${C.info} !important` }} />}
//             sx={{ bgcolor: C.infoBg, color: C.info, border: "0.5px solid #BFDBFE", fontSize: 11, fontWeight: 500 }}
//           />
//           <Box component="span" onClick={fetchAll} title="Refresh now"
//             sx={{ cursor: "pointer", color: C.muted, display: "flex", alignItems: "center", "&:hover": { color: C.accent } }}>
//             <Refresh sx={{ fontSize: 18 }} />
//           </Box>
//         </Box>
//       </Box>

//       <Grid container spacing={2}>

//         {/* ══ ROW 1: Production + Distribution ══ */}

//         {/* Production Summary */}
//         <Grid item xs={12} lg={6}>
//           <SectionCard
//             title="Production Summary"
//             icon={Factory}
//             iconColor={C.warn}
//             loading={prodLoading}
//             headerRight={
//               <FilterSelect
//                 label="Plant" value={prodPlant} onChange={setProdPlant} allLabel="Plants"
//                 items={plants.map((p) => ({ value: p.plant_id, label: p.plant_name }))}
//               />
//             }
//           >
//             <LegendRow items={[
//               { label: "Cylinders Filled",  color: CHART_COLORS.cylinders  },
//               { label: "Production (KG)",   color: CHART_COLORS.production },
//               { label: "Carbide Used (KG)", color: CHART_COLORS.carbide    },
//               { label: "Acetone Used (KG)", color: CHART_COLORS.acetone    },
//             ]} />
//             <Box sx={{ position: "relative", height: { xs: 220, sm: 250 } }}>
//               <Bar data={prodChartData} options={chartOpts(activeDays)} />
//             </Box>
//           </SectionCard>
//         </Grid>

//         {/* Distribution Summary */}
//         <Grid item xs={12} lg={6}>
//           <SectionCard
//             title="Distribution Summary"
//             icon={LocalShipping}
//             iconColor={C.accent}
//             loading={distLoading}
//             headerRight={
//               <FilterSelect
//                 label="Depot" value={distDepot} onChange={setDistDepot} allLabel="Depots"
//                 items={depots.map((d) => ({ value: d.depot_id, label: d.depot_name }))}
//               />
//             }
//           >
//             <LegendRow items={[
//               { label: "Delivered Cylinders",    color: CHART_COLORS.delivered  },
//               { label: "Empty Cyls Collected",   color: CHART_COLORS.empty_col  },
//               { label: "Sales Return Cylinders", color: CHART_COLORS.sales_ret  },
//               { label: "Total Qty Delivered",    color: CHART_COLORS.qty_del    },
//             ]} />
//             <Box sx={{ position: "relative", height: { xs: 220, sm: 250 } }}>
//               <Bar data={distChartData} options={chartOpts(activeDays)} />
//             </Box>
//           </SectionCard>
//         </Grid>

//         {/* ══ ROW 2: Inventory + Customer Holding ══ */}

//         {/* Inventory — Full & Empty pair bars */}
//         <Grid item xs={12} lg={6}>
//           <SectionCard
//             title="Inventory — Full & Empty"
//             icon={Warehouse}
//             iconColor="#0891B2"
//             badge="Live"
//             loading={invLoading}
//             headerRight={
//               <ToggleButtonGroup
//                 value={invViewMode} exclusive onChange={(_, v) => v && setInvViewMode(v)}
//                 size="small" sx={toggleSx}
//               >
//                 <ToggleButton value="plant">Plant Wise</ToggleButton>
//                 <ToggleButton value="depot">Depot Wise</ToggleButton>
//               </ToggleButtonGroup>
//             }
//           >
//             <LegendRow items={[
//               { label: "Full Cylinders",  color: CHART_COLORS.full  },
//               { label: "Empty Cylinders", color: CHART_COLORS.empty },
//             ]} />
//             {!invChartData ? (
//               <Typography sx={{ fontSize: 13, color: C.muted, py: 2 }}>No inventory data available.</Typography>
//             ) : (
//               <Box sx={{ position: "relative", height: { xs: 220, sm: 250 } }}>
//                 <Bar
//                   data={invChartData}
//                   options={{
//                     ...chartOpts(invChartData.labels.length),
//                     scales: {
//                       ...chartOpts(invChartData.labels.length).scales,
//                       x: {
//                         ...chartOpts(invChartData.labels.length).scales.x,
//                         ticks: {
//                           ...chartOpts(invChartData.labels.length).scales.x.ticks,
//                           maxRotation: invChartData.labels.length > 4 ? 35 : 0,
//                           autoSkip: false,
//                         },
//                       },
//                     },
//                   }}
//                 />
//               </Box>
//             )}
//           </SectionCard>
//         </Grid>

//         {/* Customer Holding — horizontal bars by age bucket (days held) */}
//         <Grid item xs={12} lg={6}>
//           <SectionCard
//             title="Customer Holding"
//             icon={TrendingUp}
//             iconColor={C.warn}
//             badge="By Age"
//             loading={holdingLoading}
//           >
//             {!holdingHasData ? (
//               <Typography sx={{ fontSize: 13, color: C.muted, py: 2 }}>No holding data available.</Typography>
//             ) : (
//               <>
//                 <Typography sx={{ fontSize: 11, color: C.muted, mb: 1.5 }}>
//                   No. of cylinders currently at customer locations, grouped by how
//                   long they have been held (today − last delivery/transaction date).
//                 </Typography>
//                 <Box sx={{ position: "relative", height: { xs: 240, sm: 270 } }}>
//                   <Bar data={holdingChartData} options={holdingChartOpts} />
//                 </Box>
//               </>
//             )}
//           </SectionCard>
//         </Grid>

//       </Grid>
//     </Box>
//   );
// };

// export default ManagementDashboard;


import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import {
  Box, Grid, Card, CardContent, Typography, CircularProgress,
  Chip, ToggleButtonGroup, ToggleButton, FormControl,
  InputLabel, Select, MenuItem,
} from "@mui/material";
import {
  Factory, Warehouse, CheckCircle, Refresh,
  TrendingUp, LocalShipping, CalendarToday,
} from "@mui/icons-material";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement,
  Title, Tooltip, Legend,
} from "chart.js";
import axiosClient from "../../configs/axios";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

// ── Design tokens ─────────────────────────────────────────────────────────────
const C = {
  navy:      "#1B3A6B",
  accent:    "#2563EB",
  bg:        "#F0F4F8",
  card:      "#FFFFFF",
  border:    "#E2E8F0",
  success:   "#16A34A", successBg: "#DCFCE7",
  warn:      "#D97706", warnBg:    "#FEF3C7",
  err:       "#DC2626", errBg:     "#FEE2E2",
  info:      "#2563EB", infoBg:    "#EFF6FF",
  muted:     "#64748B",
};

const CHART_COLORS = {
  cylinders:  "#1B3A6B",
  production: "#2563EB",
  carbide:    "#D97706",
  acetone:    "#DC2626",
  delivered:  "#1B3A6B",
  empty_col:  "#D97706",
 
  qty_del:    "#16A34A",
  full:       "#16A34A",
  empty:      "#D97706",
};

const REFRESH_MS = 60_000;

// ── Period config ─────────────────────────────────────────────────────────────
const PERIODS = [
  { value: "today",  label: "Today",        days: 1  },
  { value: "7days",  label: "Last 7 Days",  days: 7  },
  { value: "30days", label: "Last 30 Days", days: 30 },
];

// ── Customer Holding age-bucket config ────────────────────────────────────────
const HOLDING_BUCKETS = [
  { key: "0-7",   label: "0-7 Days",   min: 0,  max: 7   },
  { key: "8-15",  label: "8-15 Days",  min: 8,  max: 15  },
  { key: "16-30", label: "16-30 Days", min: 16, max: 30  },
  { key: "31-45", label: "31-45 Days", min: 31, max: 45  },
  { key: "46-60", label: "46-60 Days", min: 46, max: 60  },
  { key: "60+",   label: "60+ Days",   min: 61, max: Infinity },
];

const HOLDING_BUCKET_COLORS = {
  "0-7":   "#16A34A",
  "8-15":  "#2563EB",
  "16-30": "#D97706",
  "31-45": "#EA580C",
  "46-60": "#DC2626",
  "60+":   "#7F1D1D",
};

// ── Helpers ───────────────────────────────────────────────────────────────────
const toDateKey = (v) => {
  if (!v) return null;
  const s = String(v);
  return s.includes("T") ? s.split("T")[0] : s.split(" ")[0];
};

const getDays = (n) =>
  Array.from({ length: n }, (_, i) => {
    const d = new Date();
    d.setDate(d.getDate() - (n - 1 - i));
    return d.toISOString().split("T")[0];
  });

const formatLabel = (iso, n) => {
  const d = new Date(iso);
  if (n === 1) return d.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" });
  if (n <= 7)  return d.toLocaleDateString("en-IN", { month: "short", day: "numeric" });
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
};

const groupByDay = (arr, dateField, valueFields) => {
  const map = new Map();
  arr.forEach((r) => {
    const key = toDateKey(r[dateField]);
    if (!key) return;
    if (!map.has(key)) {
      const init = {};
      valueFields.forEach((f) => (init[f] = 0));
      map.set(key, init);
    }
    const o = map.get(key);
    valueFields.forEach((f) => { o[f] += Number(r[f]) || 0; });
  });
  return map;
};

const daysHeld = (dcDate) => {
  if (!dcDate) return null;
  const key = toDateKey(dcDate);
  const d = new Date(key);
  if (isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  const diffMs = today.getTime() - d.getTime();
  return Math.floor(diffMs / (1000 * 60 * 60 * 24));
};

const bucketForDays = (days) => {
  if (days == null) return null;
  return HOLDING_BUCKETS.find((b) => days >= b.min && days <= b.max)?.key ?? null;
};

// ── Chart options ─────────────────────────────────────────────────────────────
// KEY FIX: maxBarThickness added globally so single-point (Today) bars
// never stretch full-width. barPercentage + categoryPercentage control
// spacing between grouped bars across all period lengths.
// const chartOpts = (n) => ({
//   responsive: true,
//   maintainAspectRatio: false,
//   plugins: {
//     legend: { display: false },
//     tooltip: { mode: "index", intersect: false },
//   },
//   scales: {
//     x: {
//       ticks: {
//         autoSkip: n > 15,
//         maxRotation: n > 15 ? 45 : 0,
//         font: { size: 10 },
//         color: C.muted,
//       },
//       grid: { display: false },
//     },
//     y: {
//       beginAtZero: true,
//       ticks: { font: { size: 10 }, color: C.muted },
//       grid: { color: "rgba(0,0,0,0.04)" },
//     },
//   },
// });
const chartOpts = (n) => ({
  responsive: true,
  maintainAspectRatio: false,
  layout: { padding: { top: 20 } },
  plugins: {
    legend: { display: false },
    tooltip: { mode: "index", intersect: false },
    datalabels: {
      anchor: "end",
      align: "end",
      color: C.navy,
      font: { size: 10, weight: "600" },
      formatter: (value) => (value === 0 ? "" : value),
    },
  },
  scales: {
    x: {
      ticks: {
        autoSkip: n > 15,
        maxRotation: n > 15 ? 45 : 0,
        font: { size: 10 },
        color: C.muted,
      },
      grid: { display: false },
    },
    y: {
      beginAtZero: true,
      ticks: { font: { size: 10 }, color: C.muted },
      grid: { color: "rgba(0,0,0,0.04)" },
    },
  },
});

// Horizontal bar options for Customer Holding (age buckets)
const holdingChartOpts = {
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  layout: { padding: { right: 30 } },
  plugins: {
    legend: { display: false },
    tooltip: {
      mode: "index",
      intersect: false,
      callbacks: {
        label: (ctx) => `${ctx.parsed.x} cylinder${ctx.parsed.x === 1 ? "" : "s"}`,
      },
    },
    datalabels: {
      anchor: "end",
      align: "end",
      color: C.navy,
      font: { size: 10, weight: "600" },
      formatter: (value) => (value === 0 ? "" : `${value}`),
    },
  },
  scales: {
    x: {
      beginAtZero: true,
      ticks: { precision: 0, font: { size: 10 }, color: C.muted },
      grid: { color: "rgba(0,0,0,0.04)" },
    },
    y: {
      ticks: { font: { size: 11, weight: 600 }, color: C.navy },
      grid: { display: false },
    },
  },
};
// ── Sub-components ────────────────────────────────────────────────────────────

const SectionCard = ({ title, icon: Icon, iconColor = C.accent, badge, loading, children, headerRight }) => (
  <Card elevation={0} sx={{ border: `1px solid ${C.border}`, borderRadius: "12px", bgcolor: C.card, height: "100%" }}>
    <CardContent sx={{ p: "18px 20px !important" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5, flexWrap: "wrap", gap: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          <Icon sx={{ fontSize: 16, color: iconColor }} />
          <Typography sx={{ fontSize: 13, fontWeight: 700, color: C.navy }}>{title}</Typography>
          {badge && (
            <Chip label={badge} size="small"
              sx={{ fontSize: 10, fontWeight: 600, height: 20, bgcolor: C.infoBg, color: C.info, border: "0.5px solid #BFDBFE" }}
            />
          )}
        </Box>
        {headerRight}
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 220 }}>
          <CircularProgress size={26} sx={{ color: C.accent }} />
        </Box>
      ) : children}
    </CardContent>
  </Card>
);

const LegendRow = ({ items }) => (
  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 1.5 }}>
    {items.map((l) => (
      <Box key={l.label} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Box sx={{ width: 10, height: 10, borderRadius: "2px", bgcolor: l.color, flexShrink: 0 }} />
        <Typography sx={{ fontSize: 11, color: C.muted }}>{l.label}</Typography>
      </Box>
    ))}
  </Box>
);

const FilterSelect = ({ label, value, onChange, items, allLabel = "All" }) => (
  <FormControl size="small" sx={{ minWidth: 145 }}>
    <InputLabel sx={{ fontSize: 12 }}>{label}</InputLabel>
    <Select
      value={value} label={label} onChange={(e) => onChange(e.target.value)}
      sx={{
        fontSize: 12, borderRadius: "8px", bgcolor: "#F8FAFC",
        "& fieldset": { borderColor: C.border },
        "&:hover fieldset": { borderColor: C.accent },
        "&.Mui-focused fieldset": { borderColor: C.accent },
      }}
    >
      <MenuItem value=""><em>All {allLabel}</em></MenuItem>
      {items.map((it) => (
        <MenuItem key={it.value} value={String(it.value)} sx={{ fontSize: 12 }}>{it.label}</MenuItem>
      ))}
    </Select>
  </FormControl>
);

// ── TOGGLE STYLE (shared) ─────────────────────────────────────────────────────
const toggleSx = {
  "& .MuiToggleButton-root": {
    fontSize: 11, fontWeight: 500, color: C.muted,
    px: 1.5, py: 0.4, border: `1px solid ${C.border}`, textTransform: "none",
    "&.Mui-selected": { bgcolor: C.navy, color: "#fff", borderColor: C.navy, "&:hover": { bgcolor: "#122d56" } },
    "&:hover": { bgcolor: "#F8FAFC" },
  },
};

// ══════════════════════════════════════════════════════════════════════════════
//  MAIN COMPONENT
// ══════════════════════════════════════════════════════════════════════════════
const ManagementDashboard = () => {

  // ── Session ───────────────────────────────────────────────────────────────
  const userInfo = useMemo(() => {
    try {
      const d = JSON.parse(sessionStorage.getItem("loginUser") || "{}");
      return d?.result?.userInfo || {};
    } catch { return {}; }
  }, []);

  // ── Masters ───────────────────────────────────────────────────────────────
  const [plants, setPlants] = useState([]);
  const [depots, setDepots] = useState([]);

  // ── GLOBAL period ─────────────────────────────────────────────────────────
  const [period, setPeriod] = useState("7days");
  const activeDays = useMemo(() => PERIODS.find((p) => p.value === period)?.days ?? 7, [period]);

  // ── Per-chart filters ─────────────────────────────────────────────────────
  const [prodPlant, setProdPlant] = useState("");
  const [distDepot, setDistDepot] = useState("");

  // ── Data states ───────────────────────────────────────────────────────────
  const [prodData,    setProdData]    = useState([]);
  const [distData,    setDistData]    = useState([]);
  const [invData,     setInvData]     = useState(null);
  const [holdingData, setHoldingData] = useState([]);

  const [prodLoading,    setProdLoading]    = useState(true);
  const [distLoading,    setDistLoading]    = useState(true);
  const [invLoading,     setInvLoading]     = useState(true);
  const [holdingLoading, setHoldingLoading] = useState(true);

  // ── Inventory toggle ──────────────────────────────────────────────────────
  const [invViewMode, setInvViewMode] = useState("plant");

  const [lastRefreshed, setLastRefreshed] = useState(null);
  const timerRef = useRef(null);

  // ── Fetch masters ─────────────────────────────────────────────────────────
  useEffect(() => {
    Promise.allSettled([
      axiosClient.get("/unit/list?page=0&size=999&searchKey="),
      axiosClient.get("/depot/list?page=0&size=999&searchKey="),
    ]).then(([pRes, dRes]) => {
      setPlants(pRes.status === "fulfilled"
        ? (Array.isArray(pRes.value.data) ? pRes.value.data : pRes.value.data?.data ?? []) : []);
      setDepots(dRes.status === "fulfilled"
        ? (Array.isArray(dRes.value.data) ? dRes.value.data : dRes.value.data?.data ?? []) : []);
    });
  }, []);

  // ── Date range from global period ─────────────────────────────────────────
  const dateRange = useMemo(() => {
    const toDate = new Date();
    const fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - (activeDays - 1));
    return {
      from_date: fromDate.toISOString().split("T")[0],
      to_date:   toDate.toISOString().split("T")[0],
    };
  }, [activeDays]);

  // ── Fetch production ──────────────────────────────────────────────────────
  const fetchProduction = useCallback(async () => {
    setProdLoading(true);
    const params = { report_type: "weekly", ...dateRange };
    if (prodPlant) params.plant_id = prodPlant;
    try {
      const res = await axiosClient.get("/dashboard/production", { params });
      const raw = res.data;
      setProdData(Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []));
    } catch { setProdData([]); }
    finally { setProdLoading(false); }
  }, [dateRange, prodPlant]);

  // ── Fetch distribution ────────────────────────────────────────────────────
  const fetchDistribution = useCallback(async () => {
    setDistLoading(true);
    const params = { ...dateRange };
    if (distDepot) params.depot_id = distDepot;
    try {
      const res = await axiosClient.get("/dashboard/distribution", { params });
      const raw = res.data;
      setDistData(Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []));
    } catch { setDistData([]); }
    finally { setDistLoading(false); }
  }, [dateRange, distDepot]);

  // ── Fetch inventory ───────────────────────────────────────────────────────
  const fetchInventory = useCallback(async () => {
    setInvLoading(true);
    try {
      const res = await axiosClient.get("/dashboard/inventory");
      setInvData(res.data || null);
    } catch { setInvData(null); }
    finally { setInvLoading(false); }
  }, []);

  // ── Fetch holding ─────────────────────────────────────────────────────────
  const fetchHolding = useCallback(async () => {
    setHoldingLoading(true);
    try {
      const res = await axiosClient.get("/reports/EmptyCylinderHolding?page=0&size=999&searchKey=");
      const raw = res.data;
      setHoldingData(Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []));
    } catch { setHoldingData([]); }
    finally { setHoldingLoading(false); }
  }, []);

  // ── Re-fetch on period/filter change ──────────────────────────────────────
  useEffect(() => { fetchProduction(); }, [fetchProduction]);
  useEffect(() => { fetchDistribution(); }, [fetchDistribution]);

  // ── Full refresh (mount + polling) ────────────────────────────────────────
  const fetchAll = useCallback(() => {
    fetchProduction();
    fetchDistribution();
    fetchInventory();
    fetchHolding();
    setLastRefreshed(new Date());
  }, [fetchProduction, fetchDistribution, fetchInventory, fetchHolding]);

  useEffect(() => {
    fetchInventory();
    fetchHolding();
    setLastRefreshed(new Date());
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(fetchAll, REFRESH_MS);
    return () => clearInterval(timerRef.current);
  }, []); // eslint-disable-line

  // ── Production chart data ─────────────────────────────────────────────────
  // FIX: barPercentage: 0.6, categoryPercentage: 0.5, maxBarThickness: 40
  // prevents bars from going full-width when there's only 1 data point (Today).
  const prodChartData = useMemo(() => {
    const dateKeys = getDays(activeDays);
    const map = groupByDay(prodData, "entry_date", ["cylinder_count", "total_qty_filled", "carbide", "acetone"]);
    return {
      labels: dateKeys.map((d) => formatLabel(d, activeDays)),
      datasets: [
        {
          label: "Cylinders Filled",
          data: dateKeys.map((d) => map.get(d)?.cylinder_count ?? 0),
          backgroundColor: CHART_COLORS.cylinders,
          borderRadius: 3,
          barPercentage: 0.9,
          categoryPercentage: 0.8,
          maxBarThickness: 60,
        },
        {
          label: "Production (KG)",
          data: dateKeys.map((d) => +(map.get(d)?.total_qty_filled ?? 0).toFixed(1)),
          backgroundColor: CHART_COLORS.production,
          borderRadius: 3,
          barPercentage: 0.9,
          categoryPercentage: 0.8,
          maxBarThickness: 60,
        },
        {
          label: "Carbide Used (KG)",
          data: dateKeys.map((d) => +(map.get(d)?.carbide ?? 0).toFixed(1)),
          backgroundColor: CHART_COLORS.carbide,
          borderRadius: 3,
          barPercentage: 0.9,
          categoryPercentage: 0.8,
          maxBarThickness: 60,
        },
        {
          label: "Acetone Used (KG)",
          data: dateKeys.map((d) => +(map.get(d)?.acetone ?? 0).toFixed(1)),
          backgroundColor: CHART_COLORS.acetone,
          borderRadius: 3,
          barPercentage: 0.9,
          categoryPercentage: 0.8,
          maxBarThickness: 60,
        },
      ],
    };
  }, [prodData, activeDays]);

  // ── Distribution chart data ───────────────────────────────────────────────
  // FIX: same maxBarThickness + barPercentage fix as production
  const distChartData = useMemo(() => {
    const dateKeys = getDays(activeDays);
    const map = groupByDay(distData, "entry_date", ["delivered_cylinders", "empty_cylinders_collected",  "total_qty_delivered"]);
    return {
      labels: dateKeys.map((d) => formatLabel(d, activeDays)),
      datasets: [
        {
          label: "Delivered Cylinders",
          data: dateKeys.map((d) => map.get(d)?.delivered_cylinders ?? 0),
          backgroundColor: CHART_COLORS.delivered,
          borderRadius: 3,
          barPercentage: 0.9,
          categoryPercentage: 0.7,
          maxBarThickness: 60,
        },
        {
          label: "Empty Cyls Collected",
          data: dateKeys.map((d) => map.get(d)?.empty_cylinders_collected ?? 0),
          backgroundColor: CHART_COLORS.empty_col,
          borderRadius: 3,
          barPercentage: 0.9,
          categoryPercentage: 0.7,
          maxBarThickness: 60,
        },
       
        {
          label: "Total Qty Delivered",
          data: dateKeys.map((d) => map.get(d)?.total_qty_delivered ?? 0),
          backgroundColor: CHART_COLORS.qty_del,
          borderRadius: 3,
          barPercentage: 0.9,
          categoryPercentage: 0.7,
          maxBarThickness: 60,
        },
      ],
    };
  }, [distData, activeDays]);

  // ── Inventory grouped bar chart ───────────────────────────────────────────
  // FIX: maxBarThickness: 50 for inventory (only 2 datasets, so slightly wider is ok)
  const invChartData = useMemo(() => {
    if (!invData) return null;
    let rows = [];
    if (invViewMode === "plant") {
      const r = invData.plant_wise ?? invData.plants ?? [];
      rows = r.length > 0
        ? r.map((x) => ({ label: x.plant_name || x.name || "Plant", full: Number(x.full ?? x.full_count ?? 0), empty: Number(x.empty ?? x.empty_count ?? 0) }))
        : [{ label: "All Plants", full: invData.full?.tgpl || 0, empty: invData.empty?.tgpl || 0 }];
    } else {
      const r = invData.depot_wise ?? invData.depots ?? [];
      rows = r.length > 0
        ? r.map((x) => ({ label: x.depot_name || x.name || "Depot", full: Number(x.full ?? x.full_count ?? 0), empty: Number(x.empty ?? x.empty_count ?? 0) }))
        : [{ label: "All Depots", full: invData.full?.customer || 0, empty: invData.empty?.customer || 0 }];
    }
    return {
      labels: rows.map((r) => r.label),
      datasets: [
        // {
        //   label: "Full Cylinders",
        //   data: rows.map((r) => r.full),
        //   backgroundColor: CHART_COLORS.full,
        //   borderRadius: 4,
        //   barPercentage: 0.5,
        //   categoryPercentage: 0.6,
        //   maxBarThickness: 50,
        // },
        // {
        //   label: "Empty Cylinders",
        //   data: rows.map((r) => r.empty),
        //   backgroundColor: CHART_COLORS.empty,
        //   borderRadius: 4,
        //   barPercentage: 0.5,
        //   categoryPercentage: 0.6,
        //   maxBarThickness: 50,
        // },
        { label: "Full Cylinders",  data: rows.map((r) => r.full),  backgroundColor: CHART_COLORS.full,  borderRadius: 4, barPercentage: 0.9, categoryPercentage: rows.length <= 2 ? 0.2 : 0.6, maxBarThickness: 50 },
{ label: "Empty Cylinders", data: rows.map((r) => r.empty), backgroundColor: CHART_COLORS.empty, borderRadius: 4, barPercentage: 0.9, categoryPercentage: rows.length <= 2 ? 0.2 : 0.6, maxBarThickness: 50 },  ],
    };
  }, [invData, invViewMode]);

  // ── Customer Holding bucket totals ────────────────────────────────────────
  const holdingBucketTotals = useMemo(() => {
    const totals = {};
    HOLDING_BUCKETS.forEach((b) => { totals[b.key] = 0; });

    holdingData.forEach((row) => {
      const cylinders = Array.isArray(row.cylinders) ? row.cylinders : null;

      if (cylinders && cylinders.length > 0) {
        cylinders.forEach((cyl) => {
          const d = daysHeld(cyl.dc_date || cyl.delivery_date || cyl.last_transaction_date);
          const bucket = bucketForDays(d);
          if (bucket) totals[bucket] += 1;
        });
      } else {
        const d = daysHeld(row.dc_date || row.delivery_date || row.last_transaction_date);
        const bucket = bucketForDays(d);
        const qty = Number(row.total_cylinders || 0);
        if (bucket) totals[bucket] += qty;
      }
    });

    return totals;
  }, [holdingData]);

  const holdingChartData = useMemo(() => ({
    labels: HOLDING_BUCKETS.map((b) => b.label),
    datasets: [{
      label: "Cylinders Held",
      data: HOLDING_BUCKETS.map((b) => holdingBucketTotals[b.key] ?? 0),
      backgroundColor: HOLDING_BUCKETS.map((b) => HOLDING_BUCKET_COLORS[b.key]),
      borderRadius: 4,
      barThickness: 22,
    }],
  }), [holdingBucketTotals]);

  const holdingHasData = useMemo(
    () => Object.values(holdingBucketTotals).some((v) => v > 0),
    [holdingBucketTotals]
  );

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <Box sx={{ p: { xs: "12px", sm: "16px", md: "20px" }, bgcolor: C.bg, minHeight: "100vh" }}>

      {/* ══ HEADER ══ */}
      <Box sx={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        flexWrap: "wrap", gap: 2, mb: 2.5,
      }}>
        <Box>
          <Typography sx={{ fontSize: 18, fontWeight: 700, color: C.navy }}>Management Dashboard</Typography>
          <Typography sx={{ fontSize: 12, color: C.muted, mt: 0.3 }}>
            Production · Distribution · Inventory · Customer Holding
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
          <Box sx={{
            display: "flex", alignItems: "center", gap: 1,
            bgcolor: C.card, border: `1px solid ${C.border}`,
            borderRadius: "10px", px: 1.5, py: 0.75,
          }}>
            <CalendarToday sx={{ fontSize: 14, color: C.muted }} />
            <Typography sx={{ fontSize: 11, color: C.muted, fontWeight: 600, mr: 0.5 }}>Period:</Typography>
            <ToggleButtonGroup
              value={period}
              exclusive
              onChange={(_, v) => v && setPeriod(v)}
              size="small"
              sx={toggleSx}
            >
              {PERIODS.map((p) => (
                <ToggleButton key={p.value} value={p.value}>{p.label}</ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>

          {lastRefreshed && (
            <Typography sx={{ fontSize: 11, color: C.muted }}>
              Updated {lastRefreshed.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}
            </Typography>
          )}
          <Chip
            label="Management" size="small"
            icon={<CheckCircle sx={{ fontSize: "13px !important", color: `${C.info} !important` }} />}
            sx={{ bgcolor: C.infoBg, color: C.info, border: "0.5px solid #BFDBFE", fontSize: 11, fontWeight: 500 }}
          />
          <Box component="span" onClick={fetchAll} title="Refresh now"
            sx={{ cursor: "pointer", color: C.muted, display: "flex", alignItems: "center", "&:hover": { color: C.accent } }}>
            <Refresh sx={{ fontSize: 18 }} />
          </Box>
        </Box>
      </Box>

      <Grid container spacing={2}>

        {/* ══ ROW 1: Production + Distribution ══ */}

        {/* Production Summary */}
        <Grid item xs={12} lg={6}>
          <SectionCard
            title="Production Summary"
            icon={Factory}
            iconColor={C.warn}
            loading={prodLoading}
            headerRight={
              <FilterSelect
                label="Plant" value={prodPlant} onChange={setProdPlant} allLabel="Plants"
                items={plants.map((p) => ({ value: p.plant_id, label: p.plant_name }))}
              />
            }
          >
            <LegendRow items={[
              { label: "Cylinders Filled",  color: CHART_COLORS.cylinders  },
              { label: "Production (KG)",   color: CHART_COLORS.production },
              { label: "Carbide Used (KG)", color: CHART_COLORS.carbide    },
              { label: "Acetone Used (KG)", color: CHART_COLORS.acetone    },
            ]} />
            <Box sx={{ position: "relative", height: { xs: 220, sm: 250 } }}>
              <Bar data={prodChartData} options={chartOpts(activeDays)} />
            </Box>
          </SectionCard>
        </Grid>

        {/* Distribution Summary */}
        <Grid item xs={12} lg={6}>
          <SectionCard
            title="Distribution Summary"
            icon={LocalShipping}
            iconColor={C.accent}
            loading={distLoading}
            headerRight={
              <FilterSelect
                label="Depot" value={distDepot} onChange={setDistDepot} allLabel="Depots"
                items={depots.map((d) => ({ value: d.depot_id, label: d.depot_name }))}
              />
            }
          >
            <LegendRow items={[
              { label: "Delivered Cylinders",    color: CHART_COLORS.delivered  },
              { label: "Empty Cyls Collected",   color: CHART_COLORS.empty_col  },
           
              { label: "Total Qty Delivered",    color: CHART_COLORS.qty_del    },
            ]} />
            <Box sx={{ position: "relative", height: { xs: 220, sm: 250 } }}>
              <Bar data={distChartData} options={chartOpts(activeDays)} />
            </Box>
          </SectionCard>
        </Grid>

        {/* ══ ROW 2: Inventory + Customer Holding ══ */}

        {/* Inventory — Full & Empty pair bars */}
        <Grid item xs={12} lg={6}>
          <SectionCard
            title="Inventory — Full & Empty"
            icon={Warehouse}
            iconColor="#0891B2"
            badge="Live"
            loading={invLoading}
            headerRight={
              <ToggleButtonGroup
                value={invViewMode} exclusive onChange={(_, v) => v && setInvViewMode(v)}
                size="small" sx={toggleSx}
              >
                <ToggleButton value="plant">Plant Wise</ToggleButton>
                <ToggleButton value="depot">Depot Wise</ToggleButton>
              </ToggleButtonGroup>
            }
          >
            <LegendRow items={[
              { label: "Full Cylinders",  color: CHART_COLORS.full  },
              { label: "Empty Cylinders", color: CHART_COLORS.empty },
            ]} />
            {!invChartData ? (
              <Typography sx={{ fontSize: 13, color: C.muted, py: 2 }}>No inventory data available.</Typography>
            ) : (
              <Box sx={{ position: "relative", height: { xs: 220, sm: 250 } }}>
                <Bar
                  data={invChartData}
                  options={{
                    ...chartOpts(invChartData.labels.length),
                    scales: {
                      ...chartOpts(invChartData.labels.length).scales,
                      x: {
                        ...chartOpts(invChartData.labels.length).scales.x,
                        ticks: {
                          ...chartOpts(invChartData.labels.length).scales.x.ticks,
                          maxRotation: invChartData.labels.length > 4 ? 35 : 0,
                          autoSkip: false,
                        },
                      },
                    },
                  }}
                />
              </Box>
            )}
          </SectionCard>
        </Grid>

        {/* Customer Holding — horizontal bars by age bucket */}
        <Grid item xs={12} lg={6}>
          <SectionCard
            title="Customer Holding"
            icon={TrendingUp}
            iconColor={C.warn}
            badge="By Age"
            loading={holdingLoading}
          >
            {!holdingHasData ? (
              <Typography sx={{ fontSize: 13, color: C.muted, py: 2 }}>No holding data available.</Typography>
            ) : (
              <>
                <Typography sx={{ fontSize: 11, color: C.muted, mb: 1.5 }}>
                  No. of cylinders currently at customer locations, grouped by how
                  long they have been held (today − last delivery/transaction date).
                </Typography>
                <Box sx={{ position: "relative", height: { xs: 240, sm: 270 } }}>
                  <Bar data={holdingChartData} options={holdingChartOpts} />
                </Box>
              </>
            )}
          </SectionCard>
        </Grid>

      </Grid>
    </Box>
  );
};

export default ManagementDashboard;